<template>
    <div class="text-gray-500 text-center pt-1 pb-4 text-sm font-thin">App version: {{ appVersion }}</div>
</template>

<script>
export default {
	data() {
		return {
			appVersion: this.$store.state.config.packageVersion
		}
	}
}
</script>